module.exports = __webpack_public_path__ + "static/media/stein.59a4c518.m4a";